import dayjs from 'dayjs';

export const formatDate = (date: string | number): string =>
	dayjs(date).format('DD.MM.YYYY HH:mm');
